export enum UserAction {
  ResidentCreate,
  ResidentUpdate,
  ResidentDelete,
  HealthcareProviderCreate,

  SiteCreate,
  SiteUpdate,
  SiteArchive,
  SiteFloorCreate,
  SiteFloorUpdate,
  SitePlaneArchive,

  SiteConfigurationUpdate,
  ProfileConfigurationUpdate,

  DeviceDelete,
  DeviceConfigUpdate,

  AlarmAction,
}
